import { useContext, useEffect, useRef, useState } from 'react';
import { FaGreaterThan } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AlertContext from '../../../context/Alert/AlertContext';
import AuthContext from '../../../context/Auth/AuthContext';
import axiosPrivate from '../../../hooks/axiosPrivate';
import '../Logistic/logistic.css';
import LoaderContext from '../../../context/loader/LoaderContext';
import { showErrorToast,showSuccessToast } from '../../../Toster';
import './invoice.css';
import { printWithOutEway } from './InvoiceWithoutEway';
import { printHandlerWithEway } from './InvoiceWithEway';

const Logistic = () => {
  const [data, setData] = useState({});
  const [visible, setVisible] = useState(false);
  const { setIsLoading } = useContext(LoaderContext);
  const { checkPermissionExists, authPermissions } = useContext(AuthContext);
  const { alertMessage, setAlertMessage } = useContext(AlertContext);
  const [logistics, setLogisticsState] = useState([]);
  const [userData, setUserData] = useState([]);
  const navigate = useNavigate();

  const invoicePdfModal = useRef();

  useEffect(() => {
    axiosPrivate
      .post('users')
      .then((res) => setUserData(res?.data?.data))
      .catch((error) => { });
  }, []);

  const dispatch = userData.filter((data) => data?.roles == 'Dispatch team');
  const dispatchId = dispatch.map((data) => data.id);

  const dbInvoices = async () => {
    setIsLoading(true);
    axiosPrivate
      .get('accounting/invoices')
      .then((response) => {
        setIsLoading(false);
        setLogisticsState(response?.data?.data);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    
    dbInvoices();
  }, [authPermissions]);

  useEffect(() => {
    var acc = document.getElementsByClassName('accordion-custome');
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active-custome');
        var panel = this.nextElementSibling;
        if (panel.style.display === 'block') {
          panel.style.display = 'none';
        } else {
          panel.style.display = 'block';
        }
      });
    }
  }, [logistics]);

  //State For selected items start
  const [selectedItems, setSelectedItems] = useState([]);
  const [mergerButton, setMergerButton] = useState(false);
  //State for selected items end

  //State For Merge Modal start
  const [showModal, setShowModal] = useState(false);
  //State For Merge Modal end

  useEffect(() => {
    if (alertMessage != null) {
      toast(alertMessage.message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
      setAlertMessage(null);
    }
  }, [alertMessage]);

  //Function to handle and add selected id start
  const selectItems = async (event, id) => {
    let oldLogisticSelectedIds = new Set(selectedItems);
    let selectedItemsArray = selectedItems;
    if (event.target.checked && oldLogisticSelectedIds.has(id) != true) {
      selectedItemsArray.push(id);
      setSelectedItems(selectedItemsArray);
    } else {
      let index = selectedItemsArray.indexOf(id);
      if (index > -1) {
        selectedItemsArray.splice(index, 1);
        setSelectedItems(selectedItemsArray);
        event.target.checked = false;
      }
    }
    if (selectedItemsArray.length > 0) {
      setMergerButton(true);
    } else {
      setMergerButton(false);
    }
    return true;
  };
  //Function to handle and add selected id end

  //Function to remove the selected items start
  const removeSelectedItems = () => {
    //Loop and remove checked items start
    document.querySelectorAll('.select-merge').forEach(function (checkBox) {
      checkBox.checked = false;
    });
    //Loop and remove checked items end

    setSelectedItems([]);
    setMergerButton(false);
    return true;
  };
  //Function to remove the selected items end

  //Merge Open Modal function start
  const openModal = (event) => {
    event.preventDefault();
    setShowModal(true);
  };
  //Merge Open Modal function end

  //Merge Close Modal function start
  const closeModal = () => {
    setShowModal(false);
  };
  //Merge Close Modal function end

  //Function to handle modal form submission start
  const handleConfirm = async () => {
    closeModal();
    removeSelectedItems();
    navigate(`/admin/logistics`);
    return true;
  };
  //Function to handle modal form submission end

  var acc = document.getElementsByClassName('accordion-custome');
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
      this.classList.toggle('active-custome');
      var panel = this.nextElementSibling;
      if (panel.style.display === 'block') {
        panel.style.display = 'none';
      } else {
        panel.style.display = 'block';
      }
    });
  }

  const handlePrint = () => {
    window.print();
  };

  /* Function to generate a invoice start */
  const generateInvoice = async (event, item) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const fetchInvoice = await axiosPrivate.post(`accounting/invoice`, { vch_no: item.vch_no });
      let total_quantity = 0;

      // Extract quantities, convert to numbers, and sum them up
      total_quantity = fetchInvoice?.data?.data?.parsedReplacements?.products?.reduce(
        (acc, product) => {
          return acc + Number(product?.quantity || 0);
        },
        0
      );
      fetchInvoice.data.data.parsedReplacements.quantity = total_quantity;

      await printHandlerWithEway(fetchInvoice?.data?.data);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      showErrorToast(error?.response?.data?.message || 'Something went wrong');
    }
  };

  const handleWithoutEway = async (event, item) => {
    event.preventDefault();
    setIsLoading(true);
    let total_quantity = 0;

    // Extract quantities, convert to numbers, and sum them up
    total_quantity = item?.parsedReplacements?.products?.reduce(
      (acc, product) => {
        return acc + Number(product?.quantity || 0);
      },
      0
    );
    item.parsedReplacements.quantity = total_quantity;

    await printWithOutEway(item);
    setIsLoading(false);
  }

  async function notificationFunction(orderId) {
    let object = {
      title: 'Request for Order Dispatch',
      order_id: orderId,
      user_id: dispatchId[0],
      notification_for: 'dispatch',
    };
    await axiosPrivate.post('/notifications/store', object).then((res) => { });
  }
  /* Function to reset state of logistic after invoice genrate */
  const resetLogisticState = async () => {
    await axiosPrivate.get('accounting/list/items').then((response) => {
      setLogisticsState(response?.data?.data);
    });
  };
  function formatDate(inputDate) {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  }

const syncInvoices =  () => {
  setIsLoading(true);
   axiosPrivate.get('accounting/sync').then((response) => {
    showSuccessToast(response?.data?.message || 'Invoices Synced Successfully');
    dbInvoices();
    setIsLoading(false);
  }).catch((error) => {
    showErrorToast(error?.response?.data?.message || 'Something went wrong');
    setIsLoading(false);
  });
}



  return (
    <>
      <div className='section-body'>
        <div className='container-fluid'>
          {/* hearder breadcrumb */}
          <div className='card-header'>
            <strong className='top-left-heading'>Accounts</strong>

            <ol className='headerroutes breadcrumb m-0 bg-none '>
              <li className='item color-gray'>|</li>
              <li className='item'>
                <Link to='/admin/dashboard' className='route-heading item mx-2'>
                  Dashboard
                </Link>
              </li>
              <li className='item'>
                <FaGreaterThan className='grater-than-route' />
              </li>
              <li className='route-heading item mx-2 mt-1'>Accounts</li>
            </ol>
          </div>
          <div className='tab-content '>
            <div
              className='tab-pane fade show active'
              id='user-list'
              role='tabpanel'
            >
              <div className='card'>
                <div className='card-body'>
                  {/* <div className='d-flex justify-content-end'>
                    <button className='btn btn-primary' onClick={syncInvoices}>Sync Invoices</button>
                  </div> */}
                  {logistics?.map((logistic, index) => {
                    return logistic?.invoices?.length > 0 ? (
                      <div
                        key={`${logistic.location}-${index}-${Math.floor(Math.random() * 900) + 100}`}
                        style={{ padding: '0px 0px 6px 0px' }}
                      >
                        <p style={{ fontSize: '20px', fontWeight: 500 }}>
                          Dealer ( {logistic.dealerName} )
                        </p>
                        <button className='accordion-custome'>
                          <div className='d-flex'>
                            <span className='mr-auto p-2 '>
                              DEALER LOCATION{' '}
                              {logistic?.location?.toUpperCase()}
                            </span>
                          </div>
                        </button>
                        <div className='panel1'>
                          {/* Splite Items Table Start */}
                          {(() => {
                            return logistic?.invoices?.length <= 0 ? null : (
                              <div className='flex'>
                                <div className='caret1'>
                                  <div className='splited-items'>
                                    <p className='account_heading mb-0'>
                                      <strong># Orders</strong>
                                    </p>
                                    <div className='table-responsive'>
                                      <table className='table account-table'>
                                        <thead>
                                          <tr>
                                            <td>
                                              <b>S.No</b>
                                            </td>
                                            <td>
                                              <b>Order No</b>
                                            </td>
                                            <td>
                                              <b>Dealer Name</b>
                                            </td>
                                            <td>
                                              <b>Order Date</b>
                                            </td>
                                            <td>
                                              <b>Vehicle No</b>
                                            </td>
                                            <td>
                                              <b>Actions</b>
                                            </td>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {(() => {
                                            let htmlDataFirst = [];
                                            for (
                                              let i = 0;
                                              i < logistic?.invoices?.length;
                                              i++
                                            ) {
                                              htmlDataFirst.push(
                                                <tr
                                                  key={`${logistic?.location}-${logistic?.dealerName}-${Math.floor(Math.random() * 900) + 100}`}
                                                >
                                                  {
                                                    <>
                                                      <td>{i + 1}</td>
                                                      <td>
                                                        #
                                                        {logistic.invoices[i]
                                                          ?.parsedReplacements
                                                          ?.ordersNumbers
                                                          ? logistic.invoices[i]
                                                            ?.parsedReplacements
                                                            ?.ordersNumbers
                                                          : logistic.invoices[i]
                                                            .order_no}
                                                      </td>
                                                      <td>
                                                        <span>
                                                          {logistic?.dealerName}
                                                        </span>
                                                      </td>
                                                      <td>
                                                        <span>
                                                          {formatDate(
                                                            logistic.invoices[i]
                                                              ?.order_date
                                                          )}
                                                        </span>
                                                      </td>
                                                      <td>
                                                        {
                                                          logistic.invoices[i]
                                                            ?.parsedReplacements
                                                            ?.products[0]
                                                            ?.vehicle_no
                                                        }
                                                      </td>
                                                      {(() => {
                                                        return (
                                                          <td className=''>
                                                            <button onClick={(
                                                              event
                                                            ) => {
                                                              generateInvoice(
                                                                event,
                                                                logistic
                                                                  .invoices[i]
                                                              );
                                                              setVisible(
                                                                true
                                                              );
                                                            }}
                                                              className='btn btn-default btn-sm mr-2 download-invoice'>Download Invoice</button>
                                                            {/* <button
                                                              onClick={(
                                                                event
                                                              ) => {
                                                                generateInvoice(
                                                                  event,
                                                                  logistic
                                                                    .invoices[i]
                                                                );
                                                                setVisible(
                                                                  true
                                                                );
                                                              }}
                                                              className='download-eway-btn'
                                                            >
                                                              Download With e-Way Bill
                                                            </button> */}

                                                          </td>
                                                        );
                                                      })()}
                                                    </>
                                                  }
                                                </tr>
                                              );
                                            }
                                            return htmlDataFirst;
                                          })()}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })()}
                          {/* Splite Items Table end */}
                        </div>
                      </div>
                    ) : (
                      ''
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Logistic;
